/** _byteIn/_byteOut from analytic API are bits per second (despite the field name). */
export const bitsPerSecToMbps = (bitsPerSec) =>
  (Number(bitsPerSec) || 0) / 1_000_000;

const formatBandwidth = (bitsPerSec) => {
  const mbps = bitsPerSecToMbps(bitsPerSec);
  if (mbps === 0) return "0 Mbps";
  if (mbps >= 1000) {
    return `${(mbps / 1000).toFixed(2)} Gbps`;
  }
  if (mbps >= 1) {
    return `${mbps.toFixed(2)} Mbps`;
  }
  return `${(mbps * 1000).toFixed(2)} Kbps`;
};

export default formatBandwidth;
